import type { ApiCommerceChainJourney } from "@bridge-applications/pb-types";

export type ChainOfferStep = ApiCommerceChainJourney["steps"][number];

export const CHAIN_OFFER_VISIBLE_STEP_COUNT = 6;

export const CHAIN_OFFER_TIMING_MS = {
    completionMark: 583,
    advance: 800,
    unlock: 150,
} as const;

export type ChainOfferBoardPhase =
    "idle" | "completing" | "advancing" | "unlocking" | "complete";

export function orderedChainOfferSteps(
    journey: ApiCommerceChainJourney,
): ChainOfferStep[] {
    return [...journey.steps].sort(
        (left, right) => left.ordinal - right.ordinal,
    );
}

export function chainOfferWindowStart(
    journey: ApiCommerceChainJourney,
): number {
    const steps = orderedChainOfferSteps(journey);
    const maximumStart = Math.max(
        0,
        steps.length - CHAIN_OFFER_VISIBLE_STEP_COUNT,
    );
    const availableIndex = steps.findIndex(
        (step) => step.state === "AVAILABLE",
    );
    const currentIndex = availableIndex >= 0 ? availableIndex : steps.length;

    return Math.min(currentIndex, maximumStart);
}

export function visibleChainOfferSteps(
    journey: ApiCommerceChainJourney,
): ChainOfferStep[] {
    const steps = orderedChainOfferSteps(journey);
    const start = chainOfferWindowStart(journey);

    return steps.slice(start, start + CHAIN_OFFER_VISIBLE_STEP_COUNT);
}
